import React, {useState} from 'react'
import {Button, Center, FormControl, FormLabel, Input, VStack} from '@chakra-ui/react'
import styles from './LoginForm.module.css'
import {AuthAPI} from '../../../apis/AuthAPI'
import useAuthStore from '../../../stores/authStore'
import {useNavigate} from 'react-router-dom'

function LoginForm() {
    const navigate = useNavigate()
    const setAccessToken = useAuthStore((state) => state.setAccessToken)
    const setUser = useAuthStore((state) => state.setUser)

    const [formData, setFormData] = useState({
        login: '',
        password: '',
    })
    const handleChange = (event) => {
        const {name, value} = event.target
        setFormData({
            ...formData,
            [name]: value,
        })
    }
    const handleSubmit = async (event) => {
        event.preventDefault()
        AuthAPI
            .login(formData.login, formData.password)
            .then((resp) => {
                if (resp?.status === 0) {
                    setAccessToken(resp.token)
                    setUser(resp.user)
                    navigate('/countings')
                } else {
                    alert('Login failed: ' + resp?.message)
                }
            })
    }
    return (
        <Center>
            <div>
                <VStack spacing={4}>
                    <img alt={'Logo'} className={styles.logo} src='images/logo.png'/>
                    <form onSubmit={handleSubmit}>
                        <FormControl>
                            <FormLabel>Username</FormLabel>
                            <Input
                                name={'login'}
                                value={formData.login}
                                type='text'
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Password</FormLabel>
                            <Input
                                name={'password'}
                                value={formData.password}
                                type='password'
                                onChange={handleChange}
                            />
                        </FormControl>
                        <Button type='submit' colorScheme='blue'>
                            Log in
                        </Button>
                    </form>
                </VStack>

            </div>

        </Center>
    )
}

export default LoginForm